import React from 'react'
import { FaCrown } from "react-icons/fa";
import { useTranslation } from 'react-i18next';

const MessageHeading = ({ text, className, border, padding, noMargin, customPadding, crown }) => {
    const { t } = useTranslation();
    return (
        <h5 className={`${className || ''} ${!text?.length ? "headingLoader square" : ""} theme-text-color ${!border && 'theme-border-secondary-color'} ${customPadding ? customPadding : (!padding && 'pb-3')} ${noMargin ? 'mb-1' : 'mb-3'} mt-0`.trim()}>
            {t(text)} {crown && <FaCrown className='ps-1' style={{ color: '#ffc107', fontSize: '18px', marginBottom: '4px' }} />}
        </h5>
    )
}

export default MessageHeading